var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 169,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h214v169H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M0 0h213.636v118.366H0z"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.3%",
    y: "-11.4%",
    width: "112.6%",
    height: "122.8%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.304303363 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.804 63.601c-31.886 38.597 5.595 102.615 55.592 105.236 49.998 2.62 42.834-26.887 72.71-42.575 29.876-15.689 29.229 8.421 60.529-17.643 31.3-26.064 3.514-101.577-40.901-107.768-44.416-6.19-34.716 22.642-64.179 45.724C66.092 69.657 35.988 34.328 11.805 63.6",
    fill: "#EFF7FD",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)",
    transform: "translate(10 25)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 18.326,
    fontWeight: "bold",
    fill: "#EFF7FD"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 36.52,
    y: 49.119
  }, "PROMO CODE")), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M199.128 118.366H14.508C6.528 118.366 0 111.838 0 103.859V14.507C0 6.528 6.528 0 14.508 0h184.62c7.98 0 14.508 6.528 14.508 14.507v89.352c0 7.979-6.528 14.507-14.508 14.507",
    fill: "#130B66",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.507 109.366c-2.985 0-5.507-2.522-5.507-5.507V14.507C9 11.522 11.522 9 14.507 9h184.621c2.986 0 5.508 2.522 5.508 5.507v89.352c0 2.985-2.522 5.507-5.508 5.507H14.508Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.507 109.366c-2.985 0-5.507-2.522-5.507-5.507V14.507C9 11.522 11.522 9 14.507 9h184.621c2.986 0 5.508 2.522 5.508 5.507v89.352c0 2.985-2.522 5.507-5.508 5.507H14.508Z",
    stroke: "#130B66",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#130B66",
    strokeWidth: 2.054,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m60.4 115.791-.008-2.934"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#130B66",
    strokeWidth: 2.054,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5.64990005493164,5.64990005493164",
    d: "m60.377 107.207-.262-98.873"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#130B66",
    strokeWidth: 2.054,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M60.107 5.509 60.1 2.575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.268 108.16v-7.304h-23.087c3.066-3.066 4.37-6.979 4.37-10.566 0-.521-.065-1.043-.13-1.565h10.63v-6.26h-12.26c-.718-2.348-1.436-4.762-1.436-7.305 0-5.217 2.74-7.435 6.653-7.435 4.695 0 6.456 2.87 6.521 6.718h8.413c-.26-7.826-4.891-14.283-15.065-14.283-8.935 0-15.26 5.283-15.26 14.283 0 3.26.651 5.804 1.304 8.021h-5.413v6.261h7.239c.065.522.13.978.13 1.5 0 6.196-2.022 9.652-5.674 13.24l1.435 4.695h31.63Z",
    fill: "#130B66",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/voucher.2fe5412f.svg";
export { ForwardRef as ReactComponent };